module.exports = __webpack_public_path__ + "static/map-marker-c835f7eac4a61595c1501ef83e5ed9ac.png";